const eventDataBranch = (param) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `branch_click_card_cabang`,
      eventCategory: `localized landing page`,
      eventAction: `click on cabang`,
      eventLabel: `branch page - plp`,
      cabangBooking: `${param?.city?.province?.name?.toLowerCase()} - ${param?.city?.name?.toLowerCase()} - ${param?.displayName?.toLowerCase()}`,
    });
  }
};

export default eventDataBranch;
